import React from 'react';
import { IProps } from './types';

const CheckItem: React.FC<IProps> = ({ groupId, itemId, label, isChecked, onClick, ...props }) => {
  /**
   * @description 處理 onClick 執行的事件
   * @param event event object
   */
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (onClick) onClick(groupId, itemId);
  };

  return (
    <div className="cell" onClick={handleClick}>
      <span className={'checkbox' + (isChecked ? ' checked' : '')} />
      <div className={'text' + (isChecked ? ' text--active' : '')}>{label}</div>
    </div>
  );
};

export default CheckItem;
